import BigNumber from "bignumber.js";

class CurrencyFormatter {
  constructor(options = {}) {
    this.locale = options.locale || "en-US";
    this.decimalPlaces = options.decimalPlaces || 2;
    this.cryptocurrencyDecimalPlaces = options.cryptocurrencyDecimalPlaces || 2;
    this.stablecoins = options.stablecoins || ["USDT", "USDC", "DAI"];
    this.useDynamicDecimals = options.useDynamicDecimals || false;
  }

  formatFiat(amount, currency) {
    const fiatDecimalPlaces = 2;
    const formatted = new Intl.NumberFormat(this.locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: fiatDecimalPlaces,
      maximumFractionDigits: fiatDecimalPlaces,
    }).format(amount);

    let result = formatted.replace(/,(?=\d{3}(?!\d))/g, " ");

    if (currency === "ZAR") {
      result = result.replace(/ZAR\s*/g, "R ");
    }

    return result;
  }

  formatCrypto(amount, symbol, showSymbol = false) {
    const bigAmount = new BigNumber(amount);
    let decimalPlaces;

    const symbolUpper = symbol?.toUpperCase();
    if (
      symbolUpper === "BTC" ||
      symbolUpper === "BITCOIN" ||
      symbolUpper === "ETH" ||
      symbolUpper === "ETHEREUM"
    ) {
      decimalPlaces = 6;
    } else if (this.useDynamicDecimals) {
      const numValue = bigAmount.toNumber();
      if (numValue === 0) {
        decimalPlaces = 2;
      } else {
        const integerPart = Math.floor(Math.abs(numValue));
        const integerDigits = integerPart.toString().length;
        decimalPlaces = Math.max(2, 8 - integerDigits);
      }
    } else {
      decimalPlaces = this.stablecoins.includes(symbolUpper)
        ? this.decimalPlaces
        : this.cryptocurrencyDecimalPlaces;
    }

    const formatted = new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(bigAmount.toNumber());

    const formattedWithSpaces = formatted.replace(/,(?=\d{3}(?!\d))/g, " ");

    return showSymbol
      ? `${symbol} ${formattedWithSpaces}`
      : formattedWithSpaces;
  }

  format(amount, type = "fiat", currencyOrSymbol = "USD", options = {}) {
    const originalUseDynamicDecimals = this.useDynamicDecimals;
    if (options.useDynamicDecimals !== undefined) {
      this.useDynamicDecimals = options.useDynamicDecimals;
    }

    let result;
    if (type === "crypto") {
      result = this.formatCrypto(amount, currencyOrSymbol, options.showSymbol);
    } else {
      result = this.formatFiat(amount, currencyOrSymbol);
    }

    this.useDynamicDecimals = originalUseDynamicDecimals;

    return result;
  }
}

const zarUiFormatter = new CurrencyFormatter({
  locale: "en-US",
  decimalPlaces: 2,
  cryptocurrencyDecimalPlaces: 2,
});

export function formatZarDisplay(amount) {
  const n = typeof amount === "number" && Number.isFinite(amount) ? amount : 0;
  return zarUiFormatter.formatFiat(n, "ZAR");
}

export default CurrencyFormatter;
